import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Filters {
    constructor (wrapperClass) {
        this.$wrapper       = $(wrapperClass);
        this.wrapperClass   = wrapperClass;
        this.speed          = 300;
        this.submitOnChange = false;

        // Selectors
        //----------------------------------------
        // Filter Selectors
        this.$form           = this.$wrapper.find(`${this.wrapperClass}__form`);
        this.$filters        = this.$wrapper.find(`${this.wrapperClass}__filter`);
        this.$filterHeadings = this.$wrapper.find(`${this.wrapperClass}__filter-heading`);
        this.$filterLists    = this.$wrapper.find(`${this.wrapperClass}__list`);
        this.$selectAll      = this.$wrapper.find(`${this.wrapperClass}__select-all`);
        this.$checkboxes     = this.$wrapper.find(`${this.wrapperClass}__checkbox`);
        this.$reset          = $(`${this.wrapperClass}__clear`);
        this.$submit         = this.$wrapper.find(`${this.wrapperClass}__submit`);

        // Mobile Filters
        // SBTODO: Delete as necessary
        this.$mobileSearchToggle   = $('.js-search-mobile-toggle');
        this.$mobileSearchWrapper  = $('.js-search-mobile-wrapper');
        this.$mobileFiltersToggle  = $('.js-filters-mobile-toggle');
        this.$mobileFiltersWrapper = $('.js-filters-mobile-wrapper');
        this.$mobileSorterToggle   = $('.js-sorter-mobile-toggle');
        this.$mobileSorterWrapper  = $('.js-sorter-mobile-wrapper');

        // Active Filter Selectors
        this.$activeFilters = $('.js-active-filter');

        // Events
        //----------------------------------------
        // Filter Events
        this.$checkboxes.on('change', $.proxy(this.checkboxChange, this));
        this.$filterHeadings.on('click', $.proxy(this.headingClick, this));
        this.$selectAll.on('click', $.proxy(this.selectAllClick, this));
        this.$reset.on('click', $.proxy(this.resetClick, this));
        this.$submit.on('click', $.proxy(this.submitClick, this));
        $(document).on('click', $.proxy(this.documentClick, this));

        // Sorter Events
        $('.js-sorter__radio').on('change', $.proxy(this.submitClosestForm, this));

        // Mobile Events
        // SBTODO: Delete as necessary
        this.$mobileFiltersToggle.on('click', $.proxy(this.toggleMobileFilters, this));
        this.$mobileSearchToggle.on('click', $.proxy(this.toggleMobileSearch, this));
        this.$mobileSorterToggle.on('click', $.proxy(this.toggleMobileSorter, this));

        // Active Filter Events
        this.$activeFilters.on('click', $.proxy(this.activeFilterClick, this));

        // Escape Key
        $(document).keyup((e) => {
            if (e.keyCode === 27) {
                this.closeFilters(this.$filters);
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];

        this.addScrollbars();

        // Filter Counts
        //----------------------------------------
        this.addCountToHeadings();
        this.checkAllForCheckedItems();

        $(window).on('resize', $.proxy(this.closeAllFilters, this));

        $(window).on('resize', debounce(() => {
            this.updateScrollbars();
        }, 300));

        // Select All Buttons
        //----------------------------------------
        this.checkSelectAlls();

        // Relevance Score
        //----------------------------------------
        this.$relevanceScores = $('.js-relevance-score');

        this.$relevanceScores.on('click', () => {
            this.$relevanceScores.hide();
        });
    }

    addScrollbars () {
        for (let i = 0; i < this.$filterLists.length; i++) {
            this.scrollbars.push(new Ps(this.$filterLists[i]));
        }
    }

    updateScrollbars () {
        this.scrollbars.forEach((ps) => ps.update());
    }

    checkAllForCheckedItems () {
        // Check for active
        for (let i = 0; i < this.$filters.length; i++) {
            const $filter = $(this.$filters[i]);

            this.checkForCheckedItems($filter);
        }
    }

    checkForCheckedItems ($filter) {
        if ($filter.find(':checked').length) {
            $filter.addClass('is-active');
        } else {
            $filter.removeClass('is-active');
        }

        this.updateCountString($filter);
    }

    resetForm ($form) {
        $form.find(`${this.wrapperClass}__checkbox`).prop('checked', false);
        $form.find(`${this.wrapperClass}__hidden-input`).val('');

        this.checkAllForCheckedItems();
    }

    checkboxChange (e) {
        const $elem   = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.checkForCheckedItems($filter);

        this.checkSelectAlls();

        if (this.submitOnChange) {
            this.submitForm();
        }
    }

    headingClick (e) {
        const $elem   = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.closeFilters(this.$filters.not($filter));

        $filter.toggleClass('is-open').find(`${this.wrapperClass}__list`).slideToggle(this.speed, () => {
            this.updateScrollbars();
        });
    }

    documentClick (e) {
        const $elem = $(e.target);

        if (!$elem.closest(`${this.wrapperClass}__filter__list`).length && !$elem.closest(`${this.wrapperClass}__filter`).length) {
            this.closeFilters(this.$filters);
        }
    }

    closeFilters ($filters) {
        $filters.removeClass('is-open').find(`${this.wrapperClass}__list`).slideUp(this.speed);
    }

    closeAllFilters () {
        this.$filters.removeClass('is-open').find(`${this.wrapperClass}__list`).slideUp(this.speed);
        this.$mobileFiltersWrapper.removeClass('is-open');
    }

    resetClick () {
        this.resetForm(this.$form);

        this.$form.submit();
    }

    submitClick (e) {
        const $elem = $(e.target);
        const $form = $elem.closest(`${this.wrapperClass}__form`);

        this.backToFirstPage();

        $form.submit();
    }

    submitForm () {
        this.backToFirstPage();
        this.$form.submit();
    }

    submitClosestForm (e) {
        const $elem = $(e.target);

        this.backToFirstPage();

        $elem.closest('form').submit();
    }

    backToFirstPage () {
        // Go to Page 1 when new filter clicked
        this.$form.find('input[name="current-page"]').remove();
        this.$form.find('input[name="hidden-current-page"]').remove();
        this.$form.append('<input type="hidden" name="hidden-current-page" value="1" />');
    }

    toggleMobileFilters () {
        this.$mobileFiltersToggle.toggleClass('is-open');
        this.$mobileFiltersWrapper.slideToggle('300');
    }

    toggleMobileSearch () {
        this.$mobileSearchToggle.toggleClass('is-open');
        this.$mobileSearchWrapper.slideToggle('300');
    }

    toggleMobileSorter () {
        this.$mobileSorterToggle.toggleClass('is-open');
        this.$mobileSorterWrapper.slideToggle('300');
    }

    activeFilterClick (e) {
        e.preventDefault();

        const $elem        = $(e.target);
        const filterName   = $elem.closest(this.$activeFilters).data('name');
        const filterValue  = $elem.closest(this.$activeFilters).data('value');
        const $hiddenInput = $(`.js-filters__hidden-input[value="${filterValue}"]`);

        // Deal with "hidden" filters.
        if ($hiddenInput.length) {
            // Remove the hidden input
            $hiddenInput.remove();

            // Reset the pagination
            this.backToFirstPage();

            // Now submit the form
            this.$form.submit();
        } else {
            // A label exists, so set the "submitOnChange" to true, the label toggle will change the input and the form will submit
            this.submitOnChange = true;
        }
    }

    addCountToHeadings () {
        this.$filterHeadings.find(':first-child').before('<span class="c-filters__count js-filters__count"></span>');
    }

    updateCountString ($filter) {
        let countString = '';

        if ($filter.find(':checked').length) {
            countString = `${$filter.find(':checked').length} selected`;
        }

        $filter.find(`${this.wrapperClass}__count`).text(countString);
    }

    selectAllClick (e) {
        const $elem = $(e.currentTarget);

        if ($elem.hasClass('is-deselect')) {
            // Deselect all.
            $elem.closest(this.$filterLists).find(this.$checkboxes).filter(':checked').trigger('click')
        } else {
            // Select all.
            $elem.closest(this.$filterLists).find(this.$checkboxes).not(':checked').trigger('click');
        }

        this.checkAllForCheckedItems();
    }

    /**
     * If all of a filters options are selected, change the select all button to deselect mode.
     */
    checkSelectAlls () {
        for (let i = 0; i < this.$selectAll.length; i++) {
            const $button = $(this.$selectAll[i]);

            if ($button.closest(this.$filterLists).find(this.$checkboxes).not(':checked').length === 0) {
                $button.addClass('is-deselect');
            } else {
                $button.removeClass('is-deselect');
            }
        }
    }
}

export default Filters;
